import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-billing-address-page',
  templateUrl: './edit-billing-address-page.component.html',
  styleUrls: ['./edit-billing-address-page.component.scss']
})
export class EditBillingAddressPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
